import Nav from "./nav"
import QuickNav from "./quick-nav"
import ProductFilters from "./product-filters"
import SearchBar from "./search-bar"
import ProductGallery from "./product-gallery"
import ProductCategories from "./product-categories"
import Sliders from "./sliders"
import AddToCart from "./add_to_cart"
import ToggleData from "./toggle-data"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    QuickNav(jQuery)
    ProductFilters(jQuery)
    SearchBar(jQuery)
    ProductGallery(jQuery)
    ProductCategories(jQuery)
    Sliders(jQuery)
    AddToCart(jQuery)
    ToggleData(jQuery)
})
